import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ItemsEditComponent } from './items-edit/items-edit.component';
import { ItemsViewComponent } from './items-view/items-view.component';
import { ItemsComponent } from './items.component';
import { AuthGuard } from '../guards/auth.guard';
import { SuperAdminGuard } from '../guards/super-admin.guard';
import { PlanGuard } from '../guards/plan.guard';
import { AppService } from '../app.service';

const routes: Routes = [
  {
    path: 'items',
    component: ItemsComponent,
    // The pre-qualification item catalogue is platform-global (the items table has no account_id),
    // so maintaining it is system administration. Ordinary users still READ the catalogue, but they
    // do it through the item pickers in the pre-qualification builder, not through this page.
    canActivate: [
      AuthGuard,
      SuperAdminGuard,
      PlanGuard
    ],
    data: { planFeature: AppService.FEATURES.PRE_QUALIFICATIONS }
  },
  {
    path: 'items/:id/edit/:pivotId',
    component: ItemsEditComponent,
    canActivate: [
      AuthGuard,
      SuperAdminGuard
    ]
  },
  {
    path: 'items/:id/edit',
    component: ItemsEditComponent,
    canActivate: [
      AuthGuard,
      SuperAdminGuard
    ]
  },
  {
    path: 'items/:id/view/:pivotId',
    component: ItemsViewComponent,
    canActivate: [
      AuthGuard,
      SuperAdminGuard
    ]
  },
  {
    path: 'items/:id/view',
    component: ItemsViewComponent,
    canActivate: [
      AuthGuard,
      SuperAdminGuard
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ItemsRoutingModule { }
